export default () => ({
  controlButtons: {
    alignSelf: 'flex-end',
    marginTop: 60,
  },
  button: {
    marginLeft: 20,
  },
});
